import gql from "graphql-tag";
const ADD_CONTEST = gql `
  mutation addContest($contestAddInput: ContestAddInput!) {
    addContest(contestAddInput: $contestAddInput) {
      id
    }
  }
`;
export default ADD_CONTEST;
